import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { objectEquals, delay, removerAcentos } from '../../utils';
import OptionItem from './OptionItem';
import { Paper } from '@mui/material';

interface SelectSearchMultiAsyncProps<T> {
    id?: string | undefined;
    name: string;
    label: React.ReactNode;
    loadOptions: (inputValue: string, value?: OptionItem<T>[]) => Promise<OptionItem<T>[]>;
    defaultOptions: OptionItem<T>[];
    //isMulti?: Boolean;
    isClearable?: boolean;
    value: OptionItem<T>[];
    isDisabled?: Boolean;
    onChangeHandle: (name: string, value: OptionItem<T>[]) => void;
    error?: Boolean;
    required?: Boolean;
    helperText?: React.ReactNode;
    placeholder?: string;
    autoFocus?: boolean;
    style?: React.CSSProperties;
    margin?: 'none' | 'dense' | 'normal';
    //variant?: 'standard' | 'filled' | 'outlined';
    fullWidth?: boolean;
    //classes: Record<keyof ReturnType<typeof styles>, string>
}

interface SelectSearchMultiAsyncState<T> {
    options: OptionItem<T>[];
    loading: boolean;
}

class SelectSearchMultiAsync<T> extends React.Component<SelectSearchMultiAsyncProps<T>, SelectSearchMultiAsyncState<T>>{

    timer?: number;

    constructor(props: SelectSearchMultiAsyncProps<T>) {
        super(props);
        const { defaultOptions, value } = this.props;
        this.state = {
            options: defaultOptions || [],
            loading: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
    }

    private handleChange(e: React.ChangeEvent<any>, value: readonly OptionItem<T>[]) {
        const { onChangeHandle, name, loadOptions } = this.props;
        if (typeof onChangeHandle === 'function') {
            onChangeHandle(name, [...value]);
            this.loadOptions('', [...value]);
        }
    }

    private async loadOptions(text: string, values?: OptionItem<T>[]) {
        const { loadOptions } = this.props;
        this.setState({ loading: true, options: [] });
        const options = await loadOptions(text, values);
        this.setState({ loading: false, options });
    }

    private async onTextChange(text: string, reason: 'input' | 'reset' | 'clear') {
        const { name, onChangeHandle } = this.props;
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        
        if (reason === 'input') {
            this.timer = window.setTimeout(async () => {
                await this.loadOptions(text);
            }, 300);
        } else if (reason === 'clear') {
            if (typeof onChangeHandle === 'function') {
                onChangeHandle(name, []);
            }
            await this.loadOptions(text);
        }
    }

    render() {
        var { name, label, id, error, helperText, required, defaultOptions, value, isDisabled, 
            isClearable, margin, fullWidth, placeholder, autoFocus, style } = this.props;
        const { options, loading } = this.state;
        const filteredOptions = options.filter((option) =>
            !value.some((selected) => objectEquals(selected.value, option.value))
        );

        var disableClearable = !isClearable || !!required;
        return (
            <Autocomplete<OptionItem<T>, true, boolean, false>
                multiple={true}
                id={id}
                PaperComponent={PaperComponent}
                options={filteredOptions}
                loading={loading}
                getOptionDisabled={v => {
                    return !!v?.disabled;
                }}
                style={style}
                value={value}
                isOptionEqualToValue={(a, b) => objectEquals(a, b)}
                loadingText="Loading..."
                getOptionLabel={v => {
                    return v ? v.label : '';
                }}
                onChange={this.handleChange}
                onInputChange={(e, value, reason) => this.onTextChange(value, reason)}
                disableClearable={disableClearable}
                disabled={!!isDisabled}
                placeholder={placeholder}
                autoComplete={true}
                filterOptions={(t, { inputValue }) => t}
                noOptionsText="Nenhuma opção"
                renderInput={(params) => (
                    <TextField
                        {...params}
                        name={name}
                        label={label}
                        margin={margin || "normal"}
                        variant='outlined'
                        error={!!error}
                        helperText={helperText}
                        fullWidth={!!fullWidth}
                        autoFocus={autoFocus}
                        required={!!required}
                        InputProps={{
                            ...params.InputProps,
                            autoFocus: autoFocus,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                        onBlur={(ev) => {
                            /*var val = removerAcentos(ev.target.value.toUpperCase());
                            var op = options.filter((opt) => removerAcentos(opt.label.toUpperCase()).includes(val) && val.length > 2);
                            if (op.length === 1) {
                                var opValue = op[0].value;
                                if (op && value !== opValue && !op[0].disabled) {
                                    this.handleChange(ev, opValue);
                                }
                            }*/
                        }}
                    />
                )}
            />
        );
    }
}

function PaperComponent(props: React.HTMLAttributes<HTMLElement>) {
    return <Paper {...props} elevation={8} />;
}

export default <T,>(props: SelectSearchMultiAsyncProps<T>) => {
    const key = props.defaultOptions.reduce((p, o) => p + "|" + o.label, props.name);
    return <SelectSearchMultiAsync<T> key={key} {...props} />
};